import React, {Component} from 'react';
import { withTranslation } from 'react-i18next';
import {withRouter} from "react-router-dom";
import Button from "../../../../../../components/button";
import {connect} from "react-redux";
import {
    getSharingDetailsPopup,
} from "../../../../../../../actions/sharingDetailsActions";
import Icon from "../../../../../../components/icon";
import {deleteContact} from "../../../../../../../actions/contactActions";


class DeleteContactPopup extends Component {

    constructor(props){
        super(props);

        this.state = {
            isLoading: false
        };

        this.cancelHandler = this.cancelHandler.bind(this);
        this.confirmHandler = this.confirmHandler.bind(this);
    }

    cancelHandler(){
        this.props.getSharingDetailsPopup([]);
    }

    confirmHandler(){
        this.setState({
            isLoading: true
        }, () => {
            const contactsToDelete = Array.isArray(this.props.sharingDetailsPopup[2])
                ? this.props.sharingDetailsPopup[2]
                : [this.props.sharingDetailsPopup[2]];

            if(this.props.selectedContactsGroup.type === "system"){
                this.props.deleteContact(contactsToDelete, this.props.contactSearchResult.contacts.length > 0 ? '' : 6);
            } else {
                this.props.deleteContact(contactsToDelete, this.props.contactSearchResult.contacts.length > 0 ? '' : this.props.selectedContactsGroup.id);
            }

        });
    }

    render() {
        return (
            <div className="p-4">
                <h2 className="text-warning pr-5"><Icon className="mr-2" name="warning"/>{this.props.t("warning")}</h2>
                <p>{this.props.t("confirmSingleDeleteText")}</p>
                <div className="text-right">
                    <Button className="btn-link" disabled={this.state.isLoading} onClick={this.cancelHandler}>
                        {this.props.t("noText")}
                    </Button>
                    {
                        this.state.isLoading === false
                        ?
                            <Button className="btn-primary" onClick={this.confirmHandler}>
                                 {this.props.t("yesText")}
                            </Button>
                        :
                            <Button className="btn-primary" disabled={true}>
                                <Icon animated={'pulse'} name="spinner"/>
                            </Button>
                    }
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        sharingDetailsPopup: state.sharingDetailsReducer.getSharingDetailsPopup,
        selectedContactsGroup: state.contactsGroupItemReducer.getSelectedContactsGroup,
        searchResultValue: state.contactReducer.searchResultValue,
        contactSearchResult: state.contactReducer.contactSearchResult,
	    selectedContacts: state.contactReducer.selectedContacts

    }
};

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        getSharingDetailsPopup : (array) => {
            dispatch(getSharingDetailsPopup(array))
        },
        deleteContact : (array, string) => {
            dispatch(deleteContact(array, string, ownProps))
        },
    }
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTranslation()(DeleteContactPopup)));
